import { render, staticRenderFns } from "./TerrainSection.vue?vue&type=template&id=e8948376&scoped=true"
import script from "./TerrainSection.vue?vue&type=script&lang=js"
export * from "./TerrainSection.vue?vue&type=script&lang=js"
import style0 from "./TerrainSection.vue?vue&type=style&index=0&id=e8948376&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e8948376",
  null
  
)

export default component.exports